export let UploaderId;
(function (UploaderId) {
  UploaderId["VIDEO_MAIN"] = "main";
  UploaderId["VIDEO_COVER"] = "cover";
  UploaderId["VIDEO_TRAILER"] = "trailer";
  UploaderId["VIDEO_POSTER"] = "poster";
  UploaderId["CHANNEL_COVER"] = "channel-cover";
  UploaderId["EMBED_LOGO"] = "embed-logo";
  UploaderId["VIDEO_CARD_IMAGE"] = "video-card-image";
})(UploaderId || (UploaderId = {}));
//# sourceMappingURL=uploader-id.js.map